import styled from 'styled-components/native'
import StyleVariables from '../../../StyleVariables'

export const PunchCardBlock = styled.View<{ highlightcolor: string }>`
  position: relative;
  border: 1px solid ${({ highlightcolor }) => highlightcolor};
  border-radius: ${StyleVariables.borderRadiusCard};
  padding: ${StyleVariables.cardPadding};
  margin: ${StyleVariables.cardMargin};
  width: calc(100% - 40px);
  align-self: center;
`

export const PunchCardBlockHeader = styled.Text<{ fontcolor: string }>`
  font-weight: bold;
  font-size: ${StyleVariables.fontSizeBase};
  text-align: center;
  margin-bottom: 16px;
  color: ${({ fontcolor }) => fontcolor};
`

export const PunchCardCard = styled.View`
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 8px;
`

export const PunchCardName = styled.Text<{ fontcolor: string }>`
  font-weight: bold;
  font-size: ${StyleVariables.fontSizeBase};
  color: ${({ fontcolor }) => fontcolor};
`

export const PunchCardDescription = styled.Text<{ fontcolor: string }>`
  font-size: ${StyleVariables.fontSizeBase};
  margin-top: 4px;
  color: ${({ fontcolor }) => fontcolor};
`

export const PunchCardDetails = styled.View`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-top: 8px;
`

export const PunchCardDetailItem = styled.View`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`

export const PunchCardDetailText = styled.Text<{ fontcolor: string }>`
  font-size: 12px;
  color: ${({ fontcolor }) => fontcolor};
  margin-left: 8px;
`
